export enum FormType {
    CREATE,
    EDIT
}
